import { useMemo } from 'react';
import { useUserSettingsStore } from '../stores/userSettingsStore';
import { useActiveAnnouncementsQuery } from '../api/userAnnouncements';

export function useAnnouncements() {
    const { userSettings } = useUserSettingsStore();
    const seenAnnouncements = userSettings?.seenAnnouncements || [];
    const { data: activeAnnouncements = [] } = useActiveAnnouncementsQuery();

    const activeUnseenAnnouncements = useMemo(() => {
        return activeAnnouncements.filter(announcement => !seenAnnouncements.includes(announcement.announcementID));
    }, [activeAnnouncements, seenAnnouncements]);

    return {
        activeUnseenAnnouncements
    }
}
